import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import { useTheme } from '../theme/ThemeContext';
import { selectSymbols } from '../redux/features/platformSlice';
import { useAllPrices } from '../hooks/usePriceSubscription';
// import useTopMovers from '../hooks/useTopMovers';
import Sparkline from '../components/common/Sparkline';
// import { TrendUpIcon, TrendDownIcon } from '../helpers/Icons';
import MarketDataService from '../services/market/MarketDataService';
import { filterSymbolsByRealtimePrice, getRealtimePrice } from '../utils/symbolPriceFilter';

const CATS = ['All','Forex','Crypto','Stocks','Indices','Commodities'];

const AssetCard = ({ sym, price, onClick }) => {
  const theme = useTheme();
  const pos = price?.bid && price?.open ? price.bid>=price.open : true;
  const pct = price?.bid && price?.open && price.open!==0 ? ((price.bid-price.open)/price.open*100) : 0;
  const [hov, setHov] = useState(false);
  return (
    <div onClick={onClick} onMouseEnter={()=>setHov(true)} onMouseLeave={()=>setHov(false)} style={{
      background:hov?theme.card2:theme.card, border:`1px solid ${theme.border}`,
      borderRadius:10, padding:'12px 12px', cursor:'pointer', transition:'all 0.15s',
      display:'flex', flexDirection:'column', gap:6,
    }}>
      <div style={{ display:'flex', justifyContent:'space-between', alignItems:'flex-start' }}>
        <div>
          <div style={{ fontSize:11,fontWeight:700,color:theme.text }}>{sym.symbol}</div>
          <div style={{ fontSize:9,color:theme.textM,marginTop:1 }}>{sym.category}</div>
        </div>
        <span style={{ fontSize:9,fontWeight:700,color:pos?theme.pos:theme.neg,background:pos?theme.posBg:theme.negBg,padding:'2px 7px',borderRadius:5 }}>{pct.toFixed(2)}%</span>
      </div>
      <Sparkline symbol={sym.symbol} width={120} height={32} positive={pos}/>
      <div style={{ display:'flex', justifyContent:'space-between', alignItems:'center' }}>
        <span style={{ fontSize:13,fontWeight:700,color:theme.text,fontFamily:theme.mono,fontVariantNumeric:'tabular-nums' }}>{price?.bid?.toFixed(sym.digits)??'—'}</span>
        <span style={{ fontSize:9,color:theme.textM }}>Spr: <span style={{ fontFamily:theme.mono }}>{MarketDataService.formatSpreadInPips(price?.spread, sym.digits, price)}</span></span>
      </div>
    </div>
  );
};

// const MoverRow = ({ entry, idx, onClick }) => {
//   const theme = useTheme();
//   const pos = entry.pct>0;
//   return (
//     <div onClick={onClick} style={{ display:'flex',alignItems:'center',gap:10,padding:'7px 14px',borderBottom:`1px solid ${theme.border}22`,cursor:'pointer' }}>
//       <span style={{ fontSize:10,color:theme.textM,fontWeight:700,width:18,flexShrink:0 }}>#{idx+1}</span>
//       <div style={{ flex:1 }}>
//         <div style={{ fontSize:11,fontWeight:700,color:theme.text }}>{entry.symbol}</div>
//         <div style={{ fontSize:9,color:theme.textM }}>{entry.category}</div>
//       </div>
//       <span style={{ fontSize:12,fontWeight:700,fontFamily:theme.mono,color:pos?theme.pos:theme.neg }}>{pos?'+':''}{entry.pct.toFixed(2)}%</span>
//     </div>
//   );
// };

const MarketOverview = ({ onSelectSymbol }) => {
  const theme = useTheme();
  const prices = useAllPrices();
  const symbols = useSelector(selectSymbols);
  const [cat, setCat] = useState('All');
  // const [moverTab] = useState('risers');
  // const movers = useTopMovers();

  const pricedSymbols = filterSymbolsByRealtimePrice(symbols);
  const filtered = pricedSymbols.filter(s => cat==='All' || s.category?.toLowerCase()===cat.toLowerCase());

  const handleSelect = (sym) => {
    const meta = pricedSymbols.find(s=>s.symbol===sym);
    if (meta) onSelectSymbol(meta);
  };

  return (
    <div style={{ display:'flex', flexDirection:'column', height:'100%', overflowY:'auto', padding:'12px 16px', gap:16 }}>
      {/* Category pills */}
      <div style={{ display:'flex', gap:6, flexWrap:'wrap' }}>
        {CATS.map(c=>(
          <button key={c} onClick={()=>setCat(c)} style={{
            padding:'5px 14px',borderRadius:20,border:'none',cursor:'pointer',
            fontSize:11,fontWeight:600,fontFamily:theme.sans,
            background:cat===c?theme.primary:theme.card2,color:cat===c?'#fff':theme.textS,
          }}>{c}</button>
        ))}
      </div>

      {/* Asset grid */}
      <div>
        <div style={{ fontSize:11,fontWeight:700,color:theme.textS,marginBottom:10,letterSpacing:'0.04em' }}>Markets</div>
        <div style={{ display:'grid', gridTemplateColumns:'repeat(auto-fill,minmax(160px,1fr))', gap:8 }}>
          {filtered.map(sym=>(
            <AssetCard key={sym.symbol} sym={sym} price={getRealtimePrice(prices, sym.symbol)} onClick={()=>handleSelect(sym.symbol)}/>
          ))}
        </div>
      </div>

      {/* Top movers */}
      {/* <div style={{ display:'grid', gridTemplateColumns:'1fr 1fr', gap:16 }}>
        {['risers','fallers'].map(type=>(
          <div key={type} style={{ background:theme.card,border:`1px solid ${theme.border}`,borderRadius:10,overflow:'hidden' }}>
            <div style={{ padding:'10px 14px',borderBottom:`1px solid ${theme.border}`,display:'flex',alignItems:'center',gap:8 }}>
              {type==='risers' ? <TrendUpIcon s={14} c={theme.pos}/> : <TrendDownIcon s={14} c={theme.neg}/>}
              <span style={{ fontSize:11,fontWeight:700,color:theme.text }}>{type==='risers'?'Top Risers':'Top Fallers'}</span>
            </div>
            {movers[type].slice(0,8).map((e,i)=>(
              <MoverRow key={e.symbol} entry={e} idx={i} onClick={()=>handleSelect(e.symbol)}/>
            ))}
          </div>
        ))}
      </div> */}
    </div>
  );
};
export default MarketOverview;
